import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CreateBookingType from './../Createbookingtype';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import BookingService from './../../../services/cargobooking.service';
import Util from './../../../../shared/util/util';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import MasterService from './../../../../masterdata/services/masterdata.service';
import BookingView from './bookingview';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { BasicSelect} from 'vue-search-select';
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx';

export default {
  name: 'CreateBooking',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CreateBookingType,
    CustomExpandableTable,
    BookingView,
    Treeselect,
    BasicSelect,
    Multiselect  },
  data: function() {
    return {
      tableColumn:['AWB','#MPS','Client Ref. No','TL Type','Route Mode','Booking Mode','Client Name','Origin','Destination','Invoice Value (INR)','Phy Wt(KG)','Vol Wt(KG)','PickUp Date','Booking Date','Booking Method','Booking Status','Booking Type','Action'],
      tableItems:[],
      showcreatebooking: false,
      awbNoSearch: '',
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      CompanyList:[],
      bookingStatuslist:[
        { id:'0', label:'Pending'},
        { id:'1', label:'Booked'}
      ],
      truckloadtypelist:[
        {id:'FTL',label:'FTL'},
        {id:'PTL',label:'PTL'},
      ],
      RouteModelist:[
        {id:'Surface',label:'Surface'},
        {id:'Air',label:'Air'},
      ],
      bookingModelist:[
        {id:'Credit',label:'Credit'},
        {id:'PrePaid',label:'Prepaid'},
        {id:'To Pay',label:'FTC'},
        {id:'Cash',label:'Cash'}
      ],
      bookingMethodlist:[
        {id:'API',label:'API'},
        {id:'Upload',label:'Upload'},
        {id:'web',label:'Web'},
        {id:'App',label:'App'},
        {id:'ClientWeb',label:'ClientWeb'},
        {id:'ClientUpload',label:'ClientUpload'}
      ],
      HubList:[],
      truckLoadTypeSearch: null,
      companyNameSearch:null,
      bookingstatusSearch:null,
      routeModeSearch:null,
      bookingmodeSearch:null,
      bookingmethodSearch:null,
      BookingFromDateSearch:'',
      BookingToDateSearch:'',
      originSearch:'',
      destinationSearch:'',
      selectedOrigin:{value:'',text:''},
      selectedDestination:{value:'',text:''},
      RequestedPickUpFromDateSearch:'',
      RequestedPickUpToDateSearch:'',
      selectedBookingObj: [],
      viewBookingObj: [],
      bookingData:[],
      defaultHubID:'',
      currentHubName:'',
      userRoleFlag:null,
      statusofbooking:"",
      PendingHandover:false,
      ShipmentDropByClient:false,
      SelfCollectByClient:false,
      PendingHandoverConsignee:false

    }
  },
  computed: {

  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaultHubID = userdetail.hubID[0];
    this.currentHubName = userdetail.currentHubName;
    console.log("userdetail.rolename",userdetail.rolename);
    this.userRoleFlag = (userdetail.rolename[0] == "Hub Executive" || userdetail.rolename[0] == "Hub Incharge" || userdetail.rolename[0] == "Hub Manager" || userdetail.rolename[0] =="TSP BA Admin") ? 1:2;
    if(this.userRoleFlag == 1){
      this.originSearch = {
        'value': this.defaultHubID,
        'text': this.currentHubName
      };
    }
    await Promise.all([
      this.getCompanyShortName(),
      this.getHublist(),
      this.getBookingListing()
    ]);
    this.isLoading = false;
  },
  methods: {
    async getCompanyShortName() {
      try {
        let InputPayload = {}
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload);
        CompanyShortList = result.data.data.rows;
        let tempArr = [];
        for (var i = 0; i < CompanyShortList.length; i++) {
          tempArr.push({
            'id': CompanyShortList[i].clientbusinessaccountid,
            'label': CompanyShortList[i].clientshortname,
            'ContractId': CompanyShortList[i].id,
            'CompanyName': CompanyShortList[i].clientcompanyname,
            'ClientId': CompanyShortList[i].clientid,
            'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
            'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid,
          });
        }
       this.CompanyList = tempArr.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);
      } catch (err) {
        console.log(err);
      }
    },
    async getHublist() {
      try {
        let InputPayload = {};
        let result = await MasterService.GetHublist(InputPayload);
        let HubList = result.data.data.data;
        for (var i = 0; i < HubList.length; i++) {
          this.HubList.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectOrigin(data){
      this.selectedOrigin = data;
      this.originSearch = data.value;
    },
    selectDestination(data){
      this.selectedDestination = data;
      this.destinationSearch = data.value;
    },
    CreateBooking() {
      this.selectedBookingObj = [];
      this.showcreatebooking = true;
    },
    callParent() {
      this.showcreatebooking = false;
      this.selectedBookingObj = null;
      this.viewBookingObj = null;
      this.currentPage = 1;
      this.offset = 0;
      this.getBookingListing();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getBookingListing();
    },
    async getCustomTableEvent(event){
      if(event.actionType=="edit"){
        let selectedBookingObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedBookingObj = selectedBookingObj[0];
        this.showcreatebooking = true;
      }else if(event.actionType=="view"){
        if (this.bookingmethodSearch == 'API') {
          let viewBookingObj  = this.tableArr.filter(function(Items) {
            return Items.id == event.id;
          });
          await this.getBookingDetailsForApiBooking(viewBookingObj[0].id);
          this.bookingData = this.viewBookingObj;
          this.$nextTick(() => {
            this.$refs.childBookingViewComponentFromListing && this.$refs.childBookingViewComponentFromListing.setValues(this.viewBookingObj);
          })
        }
        else{
        let viewBookingObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.bookingData = viewBookingObj[0];
        await this.getBookingDetails(viewBookingObj[0].id);
        this.$nextTick(() => {
          this.$refs.childBookingViewComponentFromListing && this.$refs.childBookingViewComponentFromListing.setValues(this.viewBookingObj);
        })
      }
      }
    },
    async getBookingDetails(bookingid){
      try {
        this.viewBookingObj = [];
        let InputPayload = {
          bookingid: bookingid
        }
        this.isLoading = true;
        let response = await BookingService.getBookingDetails(InputPayload);
        this.viewBookingObj = response.data.data;
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    async getBookingDetailsForApiBooking(awbnumber){
      try {
        this.viewBookingObj = [];
        let InputPayload = {
          awbnumber: awbnumber
        }
        this.isLoading = true;
        let response = await BookingService.getBookingDetailsForApiBooking(InputPayload);
        if (response.data.data) {
          this.viewBookingObj = response.data.data;
        }else{
          this.$alert("No Data found", "Booking Data", "error");
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    searchBooking(){
      this.currentPage = 1;
      this.offset = 0;
      this.getBookingListing();
    },
    async getBookingListing(){
      try {
        if(this.$route.query.BookingMethod){
          this.bookingmethodSearch = (this.$route.query.BookingMethod == "Web") ? 'web' : this.$route.query.BookingMethod ;
          this.dashboardwizardsearch = true;
        }
        if(this.$route.query.BookingStatus){
          this.statusofbooking = this.$route.query.BookingStatus;
          this.dashboardwizardsearch = true;
        }
        if (this.$route.query.BookingFromDate) {
          this.BookingFromDateSearch = this.$route.query.BookingFromDate;
          this.dashboardwizardsearch = true;
        }
        if (this.$route.query.BookingToDate) {
          this.BookingToDateSearch = this.$route.query.BookingToDate;
          this.dashboardwizardsearch = true;
        }
        if (this.$route.query.Origin) {
          this.originSearch = this.$route.query.Origin;
        }
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.companyNameSearch){
          inputPayload.clientid = this.companyNameSearch.ClientId;
          inputPayload.clientbusinessaccountid = this.companyNameSearch.ClientBusinessAccountId;
        }
        if(this.awbNoSearch!=""){
          inputPayload.awbnumber = this.awbNoSearch.trim();
        }
        if(this.bookingstatusSearch!=null){
          inputPayload.bookingstatus = this.bookingstatusSearch;
        }
        if(this.truckLoadTypeSearch!=null){
          inputPayload.truckloadtype = this.truckLoadTypeSearch;
        }
        if(this.routeModeSearch!=null){
          inputPayload.routemode = this.routeModeSearch;
        }
        if(this.bookingmodeSearch!=null){
          inputPayload.bookingmode = this.bookingmodeSearch;
        }
        if(this.bookingmethodSearch!=null){
          inputPayload.bookingmethod = this.bookingmethodSearch;
        }
        if(this.originSearch!=""){
          inputPayload.originhub = this.originSearch.value;
        }
        if(this.destinationSearch!=""){
          inputPayload.destinationhubs = this.destinationSearch.value;
        }
        if(this.BookingFromDateSearch!=""){
          inputPayload.bookingfromdate = Util.DateOnlyFormat(this.BookingFromDateSearch);
        }
        if(this.BookingToDateSearch!=""){
          inputPayload.bookingtodate = Util.DateOnlyFormat(this.BookingToDateSearch);
        }
        if(this.RequestedPickUpFromDateSearch!=""){
          inputPayload.requestedpickuptimefrom = Util.DateOnlyFormat(this.RequestedPickUpFromDateSearch);
        }
        if(this.RequestedPickUpToDateSearch!=""){
          inputPayload.requestedpickuptimeto = Util.DateOnlyFormat(this.RequestedPickUpToDateSearch);
        }
        if(this.ShipmentDropByClient == true){
          inputPayload.shipmentdropbyclient = 1;
        }
        if(this.statusofbooking!=""){
          inputPayload.status = this.statusofbooking;
        }
        if(this.dashboardwizardsearch){
          inputPayload.dashboardwizardsearch = true;
        }
        if(this.PendingHandover == true){
          inputPayload.pendinghandover = 1;
        }
        if(this.SelfCollectByClient == true){
          inputPayload.selfcollectbyclient = 1;
        }
        if(this.PendingHandoverConsignee == true){
          inputPayload.pendinghandoverconsignee = 1;
        }

        let allResolved = await Promise.all([BookingService.getBookingList(inputPayload)])
        let result = allResolved[0];
        if (result.data.code == 409) {
          this.tableItems = [];
          this.totalCount = 0;
          this.isLoading = false;
          this.$alert(result.data.message, "Booking Data", "error");
          return false;
        }
        this.tableArr = result.data.data.rows;
        this.totalCount = parseInt(result.data.data.count);
        if(this.totalCount>0){
          this.tableItems = result.data.data.rows.map((el)=>{
            let action = 'EDIT';
            if((el.bookingmethod=="App" && el.status==0 ) || el.bookingmethod =='API'  || el.bookingstatus == 'Invalid' || el.bookingmethod=="ClientWeb" ){
              action = 'NOEDIT';
            }
            let bookingmode = el.bookingmode;
            if(el.bookingmode.toLowerCase()=='topay'){
              bookingmode = 'To Pay';
            }

            return {
              'id':el.id,
              'AWB':(el.clientenablempsallocation)?el.shippingid:el.awbnumber,
              '#MPS': el.numberofmps,
              'Client Ref. No': el.clientrefnumber,
              'TL Type': el.truckloadtype,
              'Route Mode': el.routemode,
              'Booking Mode': CONSTANT.BOOKING_MODE[bookingmode],
              'Client Name': el.clientname,
              'Origin': el.originhub,
              'Destination': el.destinationhubs,
              'Invoice Value (INR)': el.totalinvoicevalue,
              'Phy Wt(KG)': el.totalphysicalweight,
              'Vol Wt(KG)': (el.totalvolumetricweight)?parseFloat(el.totalvolumetricweight).toFixed(2):null,
              'PickUp Date': (el.requestedpickupdate!=null)?Util.displayDateOnlyFormat(el.requestedpickupdate):"",
              'Booking Date': Util.displayDateOnlyFormat(el.bookingdate),
              'Booking Method': el.bookingmethod.charAt(0).toUpperCase() + el.bookingmethod.slice(1),
              'Booking Status': CONSTANT.BOOKING_STATUS[el.status],
              'Booking Type' : el.bookingstatus,
              'Action': action
            }
          })
        }else{
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async downloadBookingData(){
      try {
        this.isLoading = true;
        let inputPayload = {}

        if(this.companyNameSearch!=null){
          inputPayload.clientid = this.companyNameSearch.ClientId;
          inputPayload.clientbusinessaccountid = this.companyNameSearch.ClientBusinessAccountId;
        }
        if(this.awbNoSearch!=""){
          inputPayload.awbnumber = this.awbNoSearch;
        }
        if(this.bookingstatusSearch!=null){
          inputPayload.bookingstatus = this.bookingstatusSearch;
        }
        if(this.truckLoadTypeSearch!=null){
          inputPayload.truckloadtype = this.truckLoadTypeSearch;
        }
        if(this.routeModeSearch!=null){
          inputPayload.routemode = this.routeModeSearch;
        }
        if(this.bookingmodeSearch!=null){
          inputPayload.bookingmode = this.bookingmodeSearch;
        }
        if(this.bookingmethodSearch!=null){
          inputPayload.bookingmethod = this.bookingmethodSearch;
        }
        if(this.originSearch!=""){
          inputPayload.originhub = this.originSearch.value;
        }
        if(this.destinationSearch!=""){
          inputPayload.destinationhubs = this.destinationSearch.value;
        }
        if(this.BookingFromDateSearch!=""){
          inputPayload.bookingfromdate = Util.DateOnlyFormat(this.BookingFromDateSearch);
        }
        if(this.BookingToDateSearch!=""){
          inputPayload.bookingtodate = Util.DateOnlyFormat(this.BookingToDateSearch);
        }
        if(this.RequestedPickUpFromDateSearch!=""){
          inputPayload.requestedpickuptimefrom = Util.DateOnlyFormat(this.RequestedPickUpFromDateSearch);
        }
        if(this.RequestedPickUpToDateSearch!=""){
          inputPayload.requestedpickuptimeto = Util.DateOnlyFormat(this.RequestedPickUpToDateSearch);
        }
        if(this.ShipmentDropByClient == true){
          inputPayload.shipmentdropbyclient = 1;
        }
        if(this.PendingHandover == true){
          inputPayload.pendinghandover = 1;
        }
        if(this.SelfCollectByClient == true){
          inputPayload.selfcollectbyclient = 1;
        }
        if(this.PendingHandoverConsignee == true){
          inputPayload.pendinghandoverconsignee = 1;
        }
        if(this.statusofbooking!=""){
          inputPayload.status = this.statusofbooking;
        }
        if(this.dashboardwizardsearch){
          inputPayload.dashboardwizardsearch = true;
        }
        let allResolved;
        let result;
        if (this.bookingmethodSearch == "API") {
           allResolved = await Promise.all([BookingService.getApiBookingListForDownload(inputPayload)]);
        }else{
           allResolved = await Promise.all([BookingService.getBookingListForDownload(inputPayload)]);
        }
        result = allResolved[0];
        if (result.data.code == 409) {
          this.isLoading = false;
          this.tableItems = [];
          this.totalCount = 0;
          this.$alert(result.data.message, "Booking Data", "error");
          return false;
        }
        if(result.data.data.count>0){
          let tempData = result.data.data.rows.map((el)=>{
            let bookingmode = el.bookingmode;
            if(el.bookingmode.toLowerCase()=='topay'){
              bookingmode = 'To Pay';
            }
            return {
              'AWB':(el.clientenablempsallocation)?el.shippingid:el.awbnumber,
              '#MPS': el.numberofmps,
              'Client Ref. No': el.clientrefnumber,
              'TL Type': el.truckloadtype,
              'Route Mode': el.routemode,
              'Booking Mode': CONSTANT.BOOKING_MODE[bookingmode],
              'Client Name': el.clientname,
              'Origin': el.originhub,
              'Destination': el.destinationhubs,
              'Invoice Value (INR)': el.totalinvoicevalue,
              'Phy Wt(KG)': el.totalphysicalweight,
              'Vol Wt(KG)': el.totalvolumetricweight,
              'PickUp Date': (el.requestedpickupdate!=null)?Util.displayDateOnlyFormat(el.requestedpickupdate):"",
              'Booking Date': Util.displayDateOnlyFormat(el.bookingdate),
              'Booking Method': el.bookingmethod.charAt(0).toUpperCase() + el.bookingmethod.slice(1),
              'Booking Status': CONSTANT.BOOKING_STATUS[el.status]
            }
          });
          const data = XLSX.utils.json_to_sheet(tempData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,'BookingData.xlsx');
        }else{
          this.$alert("No booking records to download", "Booking Data", "error");
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    resetBooking(){
      this.currentPage = 1;
      this.offset = 0;
      this.companyNameSearch = null;
      this.awbNoSearch = "";
      this.bookingstatusSearch = null;
      this.truckLoadTypeSearch = null;
      this.routeModeSearch = null;
      this.bookingmodeSearch = null;
      this.bookingmethodSearch = null;
      this.BookingFromDateSearch = "";
      this.BookingToDateSearch = "";
      this.RequestedPickUpFromDateSearch = "";
      this.RequestedPickUpToDateSearch = "";
      this.destinationSearch = "";
      this.statusofbooking = "";
      this.selectedDestination = {};
      this.ShipmentDropByClient = false;
      this.PendingHandover = false;
      this.SelfCollectByClient = false;
      this.PendingHandoverConsignee = false;
      if(this.userRoleFlag == 1){

        this.originSearch = {
          'value': this.defaultHubID,
          'text': this.currentHubName
        };
      }
      else{
        this.originSearch = "";
        this.selectedOrigin = {};
      }
      this.getBookingListing();
    },
    clearPendingHandover(){
      this.PendingHandover = false;
    },
    clearPendingHandoverForConsignee(){
      this.PendingHandoverConsignee = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/bookingListing/bookingListing.component.js